export const SALOON_DASHBOARD_BASE_URL = "/salon/dashboard" as const;
